import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../RootState";

export const selectFilters = (state: RootState) => state.qualify.filters;
export const selectUniqueValues = (state: RootState) =>
  state.qualify.unique_values_count;

export const selectResults = (state: RootState) => state.qualify.result;

export const selectRowsSelected = createSelector((state) => state.qualify.rows_selected, (rows_selected: any) => ({ rowsSelected: rows_selected }))

export const selectMunicipalities = (state: RootState) =>
  state.qualify.municipalities;
export const selectLoading = (state: RootState) => state.qualify.loading;

export const selectWhatsapp = createSelector((state) => state.qualify, ({ loading_whatsapp, open_modal_confimation, modal_message }) => ({
  loading_whatsapp: loading_whatsapp,
  open_whatsapp_confirmation: open_modal_confimation,
  modal_message: modal_message
}))

export const selectrowSelectedWhatsapp = (state: RootState) =>
  state.qualify.rows_selected_whatsapp;
export const selectFiltersRequest = (state: RootState) =>
  state.qualify.filtersRequest;

export const selectMessagesInfo = createSelector((state) => state.qualify, (qualify) => qualify)
export const selectProcessEnded = createSelector((state) => state.qualify.proccess_ended, (proccess_ended) => proccess_ended)
export const selectFeedNameList = createSelector((state) => state.qualify, ({feed_name_list, loading_feed }) => ({feed_name_list, loading_feed}))